import { render } from "./DormantUsers.vue?vue&type=template&id=e73b7e2a"
import script from "./DormantUsers.vue?vue&type=script&lang=js"
export * from "./DormantUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__